import {HubConnection} from "@microsoft/signalr"
import {type StoreApi} from "zustand/vanilla"

export type LayoutObject = {
  name: string
  title?: string
  path: string
  icon?: string
}

type AuthStoreValues = {
  token: string
  isAdmin: boolean
  isProjectOwner: boolean
  appId: string
  scope: string
  redirectUri: string
  authority: string
  serverUrl: string
  functionAppId: string
  functionAuthority: string
  functionUserFlow: string
  functionRedirectUri: string
  functionAuthorityDomain: string
  layoutString: string
  layoutObject: LayoutObject[]
  faToken: string
  apimKey: string
}

type AuthStoreActions = {
  setToken: (token: string) => void
  setIsAdmin: (isAdmin: boolean) => void
  setIsProjectOwner: (isProjectOwner: boolean) => void
  setAppId: (appId: string) => void
  setScope: (scope: string) => void
  setRedirectUri: (redirectUri: string) => void
  setAuthority: (authority: string) => void
  setServerUrl: (serverUrl: string) => void
  setFunctionAppId: (functionAppId: string) => void
  setFunctionAuthority: (functionAuthority: string) => void
  setFunctionUserFlow: (functionUserFlow: string) => void
  setFunctionRedirectUri: (functionRedirectUri: string) => void
  setFunctionAuthorityDomain: (functionAuthorityDomain: string) => void
  setFaToken: (faToken: string) => void
  setApimKey: (apimKey: string) => void
  setConfig: (config: Partial<AuthStoreValues>) => void
  setLayoutString: (layoutString: string) => void
  setLayoutObject: (layoutObject: LayoutObject[]) => void
}

type AccountPanelStoreValues = {
  showAccountPanel: boolean
}

type AccountPanelStoreActions = {
  setShowAccountPanel: (showAccountPanel: boolean) => void
}

export type AuthStore = AuthStoreValues & AuthStoreActions
export type AccountPanelStore = AccountPanelStoreValues &
  AccountPanelStoreActions

type GuidedTourStoreValues = {
  run: boolean
  completedTour: boolean
}

type GuidedTourStoreActions = {
  setRun: (run: boolean) => void
  setCompletedTour: (completedTour: boolean) => void
}

export type GuidedTourStore = GuidedTourStoreValues & GuidedTourStoreActions

// signal R

//request types
export type RequestType = {
  type: string //file_upload, user_create, etc
  source: string //pdf, docx, png, etc
}

//any new request type should go here. e.g. file_upload, user_create, etc
export const REQUEST_TYPES = {
  FILE_UPLOAD: "FILE_UPLOAD",
  WEB_REPORT_UPLOAD: "WEB_REPORT_UPLOAD",
}

//request queue store
export type RequestObject = {
  url: string
  method: string
  headers: any
  body: any
  displayName: string
  state: REQUEST_STATUS
  id: string | null
  requestType: RequestType
  callbackFunction: ((response: any) => Promise<void>) | null
}

export enum REQUEST_STATUS {
  "QUEUED",
  "INPROGRESS",
  "COMPLETED",
  "SIGNALR",
  "FAILED",
}

export type RequestsQueueStoreStates = {
  isBusy: boolean
  completedRequests: Array<RequestObject>
  queuedRequests: Array<RequestObject>
}

export type RequestsQueueStoreActions = {
  setPushRequest: (request: RequestObject) => void
  setUpdateQueue: (queue: Array<RequestObject>) => void
  setUpdateCompletedRequests: (array: Array<RequestObject>) => void
  setIsBusy: (isBusy: boolean) => void
}

export type RequestsQueueStore = RequestsQueueStoreStates &
  RequestsQueueStoreActions

export type SignalRRequestObject = {
  serverUrl: string
  faToken: string
  apimKey: string
  token: string
  userId: string
}
export type SignalRConnectionState = {
  signalRConnection: HubConnection | null
  signalRRequest: SignalRRequestObject | null
}

export type SignalRConnectionAction = {
  setSignalRConnection: (signalRConnection: HubConnection | null) => void
  setSignalRRequest: (signalRRequest: SignalRRequestObject | null) => void
}

export type SignalRStore = SignalRConnectionState & SignalRConnectionAction

export type RootProps = {
  authStore: StoreApi<AuthStore>
  accountPanelStore: StoreApi<AccountPanelStore>
  guidedTourStore: StoreApi<GuidedTourStore>
  requestsQueueStore: StoreApi<RequestsQueueStore>
  signalRStore: StoreApi<SignalRStore>
}
